<template>
  <div class="freespins-container col-12 mt-3 mt-lg-5 mx-auto px-3">
    <b-list-group v-if="freespinsData.length" class="col-12 mx-auto pr-0">
      <b-list-group-item v-for="(freespin, idx) in freespinsData" :key="idx"
        class="freespin-item mb-4 white-color">
        <b-row>
          <div class="col-4 col-sm-2 col-md-3 col-lg-2">
            <img :src="$config.storageUrl +'/'+ freespin.game.picture.replace(/^\/|\/$/g, '')"
                 alt="VipMagnit онлайн Казино"
                 class="mx-auto freespin-img">
          </div>
          <div class="col-8 col-sm-10 col-md-9 col-lg-10">
            <span>{{ freespin.game.name }}</span><br>
            <span>Вам доступно {{ freespin.count }} фриспинов</span>
            <div class="col-12 px-0">
              <button class="btn main-btn w-100 text-white my-3" @click="launchUrl(freespin)">Играть</button>
            </div>
          </div>
        </b-row>
      </b-list-group-item>
    </b-list-group>
    <div v-else class="text-center">
      <span class="gray-color">У вас пока нет фриспинов</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Freespins',
  computed: {
    freespinsData() {
      return this.$store.getters['getFreespins']
    }
  },
  methods: {
    launchUrl(freespin){
      const gameName = freespin.game.name.split(' ').join('-')
      return this.$router.push({
        name: 'LaunchGame',
        params: {
          gameName: gameName,
          gameId: freespin.game.id,
          game: freespin.game,
          roundId: freespin.id,
          provider: freespin.system,
          isLive: freespin.game.isLive,
          restoring: false
        }
      })
    }
  }
}
</script>

<style scoped>
.freespin-img {
  width: 80px;
  max-width: 100%;
  max-height: 80px;
  object-fit: contain;
  border-radius: 7px;
}

.freespin-item {
  background-color: #151c2d !important;
  border: unset !important;
  border-radius: 3px !important;
  box-shadow: 0 0 3px 1px #000 inset !important;
}
</style>
